
<template>
  <div class="app-container">
    <el-button
      @click="dialogVisible = true"
      type="primary"
      :disabled="disabled"
    >
      {{ buttonName }}
    </el-button>
    <el-dialog
      :title="buttonName"
      :visible.sync="dialogVisible"
      width="800"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <div class="upload-center">
        <el-upload
          class="upload-demo"
          ref="upload"
          drag
          action="123456"
          :auto-upload="false"
          :on-change="fileChange"
          :before-upload="beforeAvatarUpload"
          :on-remove="handleRemove"
          multiple
          :accept="accept"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <!-- <div class="el-upload__tip" slot="tip">
            只能上传cvs文件，且不超过10MB
          </div> -->
          <div class="el-upload__tip" slot="tip" v-if="downLoadUrl != ''">
            点击
            <el-button type="text" @click="downLoad()">下载模板</el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="ok()" :loading="isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 文件导入通用组件（拖拽上传 FormData）
 * 功能：支持下载模板、多文件上传，超 10M 拦截
 */
import { imporstExcel } from "@/api/user";
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    downLoadUrl: {
      type: String,
      default: "",
    },
    downLoadFileName: {
      type: String,
      default: "导入模板",
    },
    buttonName: {
      type: String,
      default: "导入",
    },
    param: { type: Object, default: {} },
    text: {
      type: String,
      default: "id",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept:{
       type: String,
       default:".jpg,.jpeg,.png"
    }
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      isUpload: false,
      file: [],
      imgName: [],
    };
  },
  filters: {},
  created() {},
  methods: {
    downLoad() {
      exportExcel("", this.downLoadUrl)
        .then((result) => {
          let blob = new Blob([result], {
            type: "text/plain;charset=utf-8;",
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download =
            this.downLoadFileName + Date.parse(new Date()) + ".csv"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {});
    },
    fileChange(file) {
      console.log(file);
      this.imgName.push(file.name);
      this.file.push(file.raw);
      // this.file = file.raw; //上传文件变化时将文件对象push进files数组
      var fileName = new Array();
      // fileName = this.file.name.split(".");
      // const extension = fileName[fileName.length - 1] === "csv";
      const isLt2M = file.size / 1024 / 1024 < 10;
      // if (!extension) {
      //   this.$message({
      //     message: "上传模板只能是csv格式!",
      //     type: "warning"
      //   });
      //   this.$refs.upload.clearFiles();
      // }
      if (!isLt2M) {
        this.$message({
          message: "上传模板大小不能超过10MB!",
          type: "warning",
        });
        this.$refs.upload.clearFiles();
        this.imgName = [];
        this.file = [];
      }
      if (isLt2M == true) {
        this.isUpload = true;
      } else {
        this.isUpload = false;
      }
    },
    beforeAvatarUpload(file) {},
    /** 移除文件时重新收集剩余文件列表 */
    handleRemove(file, fileList) {
      // console.log("移除-------------", file, fileList);
      this.file = [];
      this.imgName = [];
      fileList.length > 0 &&
        fileList.forEach((item) => {
          this.file.push(item.raw);
          this.imgName.push(item.name);
        });
    },
    /** 确定导入：以 FormData 上传所选文件并通知父组件刷新 */
    ok() {
      if (this.isUpload) {
        let fd = new FormData();
        for (var i = 0; i < this.file.length; i++) {
          fd.append("file", this.file[i]);
        }
        if (this.text) {
          fd.append(this.text, this.param[this.text]);
        }
        this.isLoading = true;
        imporstExcel(fd, this.url).then((result) => {
          if (result.code == 200) {
            this.isLoading = false;
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.$emit("getList");
            this.$emit("getImgName", this.imgName);
            this.$emit("getImgSrc", result.data);
            this.file = [];
            this.imgName = [];
          }
          this.dialogVisible = false;
          this.file = [];
          this.imgName = [];
          this.$refs.upload.clearFiles();
          this.isLoading = false;
        });
      } else {
        this.$message({
          message: "没有选择文件",
          type: "info",
        });
      }
    },
    /** 取消导入并清空已选文件 */
    cancel() {
      this.dialogVisible = false;
      this.isLoading = false;
      this.file = [];
      this.imgName = [];
      this.$refs.upload.clearFiles();
    },
  },
};
</script>
